// stores/filters.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { FilterQuery } from '@monolog/shared/types';

export const useFiltersStore = defineStore('filters', () => {
  const filtersByKey = ref<Record<string, FilterQuery[]>>({});

  function setFilters(key: string, filters: FilterQuery[]) {
    filtersByKey.value[key] = filters;
  }

  function getFilters(key: string): FilterQuery[] {
    return filtersByKey.value[key] || [];
  }

  function clearFilters(key: string) {
    filtersByKey.value[key] = [];
  }

  return {
    clearFilters,
    filtersByKey,
    getFilters,
    setFilters,
  };
});
